// outerWidth у фоновой вкладки (открытой через Ctrl+клик) равен 0 до фокуса —
// fallback на clientWidth, который корректен и в фоне
export const getWindowWidth = (): number =>
  window.outerWidth || document.documentElement.clientWidth
